module.exports = __webpack_public_path__ + "static/item--bed@3x.8ed669c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bedroom/item--bed@3x.png
// module id = 1268
// module chunks = 6850842914447